export default __webpack_public_path__ + "static/media/personaluser.fb38f1e4.svg";